import { useEffect } from 'react';

const useScrollAnimation = () => {
  useEffect(() => {
    const scrollElements = document.querySelectorAll('.fade-in, .slide-in');
    
    const introElements = document.querySelectorAll('.fade-in-immediate');
    introElements.forEach((el) => el.classList.add('show'));

    const elementInView = (el, scrollOffset = 1) => {
      const elementTop = el.getBoundingClientRect().top;
      return (
        elementTop <= (window.innerHeight || document.documentElement.clientHeight) / scrollOffset
      );
    };

    const displayScrollElement = (element) => {
      element.classList.add('show');
    };

    const handleScrollAnimation = () => {
      scrollElements.forEach((el) => {
        if (elementInView(el, 1.25)) {
          displayScrollElement(el);
        }
      });
    };
    window.addEventListener('scroll', () => {
        const elements = document.querySelectorAll('.fade-in, .slide-in');
        elements.forEach(el => {
            const position = el.getBoundingClientRect().top;
            const windowHeight = window.innerHeight;
            
            if (position < windowHeight - 100) {
                el.classList.add('show');
            } else {
                el.classList.remove('show'); // Ensures animation triggers again when scrolling back
            }
        });
    });

    window.addEventListener('scroll', handleScrollAnimation);
    return () => window.removeEventListener('scroll', handleScrollAnimation);
  }, []);
};

export default useScrollAnimation;
